import _util from '../../utils/';


const OvertimeApprovalService = {
	selectOvertimeApproval(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalOvertime/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	selectOvertimeApprovalManage(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalOvertime/ManagerGet',
			params: data,
			success: resolve,
			error: reject
		})
	},
	deleteOvertimeApproval(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalOvertime/BatchDelete',
			method: "delete",
			data: data,
			success: resolve,
			error: reject
		})
	},
	updateOvertimeApproval(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalOvertime/Approval',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	updateOvertimeBatchApproval(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalOvertime/BatchApproval',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	createOvertimeApproval(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAirticketSubsidy/Post',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},


	exportOvertimeApproval(gets, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalOvertime/Export',
			params: gets,
			success: resolve,
			error: reject
		})      
	},
	fetchOvertimeList(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalOvertime/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	fetchCcToMe (data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalOvertime/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	fetchApproved (data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalOvertime/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
};


export default OvertimeApprovalService;


// WEBPACK FOOTER //
// ./src/services/Approval/overtime-approval-service.js